// Import globalnych stylów i skryptów
require('./assets/scss/_all.scss'); // Style globalne dla frontu
require('./assets/js/app'); // Skrypty globalne dla frontu
require('./src/index'); //react app

